/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    GoCancelsRow,
    GoCancelsRowFromJSON,
    GoCancelsRowFromJSONTyped,
    GoCancelsRowToJSON,
} from './';

/**
 * Go Cancel locations
 * @export
 * @interface GoCancelsList
 */
export interface GoCancelsList {
    /**
     * 
     * @type {Array<GoCancelsRow>}
     * @memberof GoCancelsList
     */
    goCancels?: Array<GoCancelsRow>;
}

export function GoCancelsListFromJSON(json: any): GoCancelsList {
    return GoCancelsListFromJSONTyped(json, false);
}

export function GoCancelsListFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoCancelsList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'goCancels': !exists(json, 'go_cancels') ? undefined : ((json['go_cancels'] as Array<any>).map(GoCancelsRowFromJSON)),
    };
}

export function GoCancelsListToJSON(value?: GoCancelsList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'go_cancels': value.goCancels === undefined ? undefined : ((value.goCancels as Array<any>).map(GoCancelsRowToJSON)),
    };
}


